import { createFileRoute } from '@tanstack/react-router'
import FormTemplateVariableLookup from '../components/form-template-variables/FormTemplateVariableLookup'

export const Route = createFileRoute('/_a/templateVariables/lookup')({
  component: FormTemplateVariableLookup,
})
